import { getAccessToken } from '../utils/session'
import {
  BASE_URL,
  GET_STATE_API,
  GET_MINISTRIES_API,
  GET_ENTITY_TYPES_API,
  SAVE_TAN_MASTER_API,
  GET_TAN_MASTER_LIST_API,
  DELETE_TAN_MASTER_API,
  DOWNLOAD_TAN_MASTER_EXCEL_API,
  UPDATE_TAN_MASTER_API,
  UPLOAD_CSI_FILE_API,
  GET_TAN_BY_ENTITY_UUID_API
} from '../endpoints/apiEndpoints'
import { sanitizeText } from '../constants'
export async function getState() {
  const accessToken = getAccessToken()
  if (!accessToken) throw new Error('Missing access token in sessionStorage')
  const res = await fetch(`${BASE_URL}/${GET_STATE_API}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })

  if (!res.ok) throw new Error(`Failed to get users: ${res.status}`)
  return await res.json()
}

export async function getMinistries() {
  const accessToken = getAccessToken()
  if (!accessToken) throw new Error('Missing access token in sessionStorage')
  const res = await fetch(`${BASE_URL}/${GET_MINISTRIES_API}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })

  if (!res.ok) throw new Error(`Failed to get ministries: ${res.status}`)
  return await res.json()
}

export async function getEntityTypes() {
  const accessToken = getAccessToken()
  if (!accessToken) throw new Error('Missing access token in sessionStorage')
  const res = await fetch(`${BASE_URL}/${GET_ENTITY_TYPES_API}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })

  if (!res.ok) throw new Error(`Failed to get entity types: ${res.status}`)
  return await res.json()
}

export async function saveTanMaster(tanMasterData, existingFileName) {
  const accessToken = getAccessToken()
  if (!accessToken) throw new Error('Missing access token in sessionStorage')

  const res = await fetch(`${BASE_URL}/${SAVE_TAN_MASTER_API}/${existingFileName}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
      Accept: '*/*',
    },
    body: JSON.stringify(tanMasterData),
  })
  let data = null
  try {
    data = await res.json()
  } catch (e) {
    data = null
  }

  if (!res.ok) {
    const error = new Error(`Failed to save TAN Master: ${res.status}`)
    error.details = data.error
    throw error
  }

  return data
}

export async function updateTanMAster(tanMasterData, uuid) {
  const accessToken = getAccessToken()
  if (!accessToken) throw new Error('Missing access token in sessionStorage')

  const res = await fetch(`${BASE_URL}/${UPDATE_TAN_MASTER_API}/${uuid}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
      Accept: '*/*',
    },
    body: JSON.stringify(tanMasterData), // sending tanMasterData as the payload
  })

  if (!res.ok) throw new Error(`Failed to save TAN Master: ${res.status}`)
  return
}

export async function getTANList(payload) {
  const defaultPayload = {
    pageFilter: {
      currentPage: 1,
      includeCount: true,
      pageSize: 100,
      sortField: 'taxDeductionAccountNumber',
      sortOrder: 'ASC',
    },
    requestFilter: [],
    isReportDownload: false,
    searchCOList: [],
  }

  const accessToken = getAccessToken()
  if (!accessToken) throw new Error('Missing access token in sessionStorage')

  const res = await fetch(`${BASE_URL}/${GET_TAN_MASTER_LIST_API}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload ? payload : defaultPayload),
  })

  if (!res.ok) throw new Error(`Failed to fetch TAN list: ${res.status}`)
  return await res.json()
}

export async function deleteTanMaster(uuid) {
  const accessToken = getAccessToken()
  if (!accessToken) throw new Error('Missing access token in sessionStorage')

  const response = await fetch(`${BASE_URL}/${DELETE_TAN_MASTER_API}${uuid}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

  if (!response.ok) {
    let errorMessage
    try {
      const errorData = await response.json()
      errorMessage =
        errorData.error || `Request failed with status: ${response.status}`
    } catch {
      errorMessage = `Request failed with status: ${response.status}`
    }
    throw new Error(errorMessage)
  }

  // If API returns no content (like 204), skip JSON parsing
  let data = null
  if (response.status !== 204) {
    try {
      data = await response.json()
    } catch {
      data = null
    }
  }

  return {
    success: true,
    data,
  }
}


export async function downloadTanMasterExcel(payload) {
  const accessToken = getAccessToken()
  if (!accessToken) throw new Error('Missing access token in sessionStorage')

  const res = await fetch(`${BASE_URL}/${DOWNLOAD_TAN_MASTER_EXCEL_API}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  })

  if (!res.ok)
    throw new Error(`Failed to download TAN Master Excel: ${res.status}`)

  // Return as Blob (Excel file)
  const blob = await res.blob()
  return blob
}




export async function uploadCsiFile(file) {
  const accessToken = getAccessToken()
  if (!accessToken) throw new Error('Missing access token in sessionStorage')

  const formData = new FormData()
  formData.append('file', file)

  const res = await fetch(sanitizeText(`${BASE_URL}/${UPLOAD_CSI_FILE_API}`), {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      Accept: '*/*',
    },
    body: formData,
  })

  let data = null
  try {
    data = await res.json()
  } catch (e) {
    data = null
  }

  if (!res.ok) {
    const error = new Error(`Failed to upload CSI File: ${res.status}`)
    error.details = data
    throw error
  }

  return data
}

export async function getTANBYEntityUUID(uuid) {
  const accessToken = getAccessToken()
  if (!accessToken) throw new Error('Missing access token in sessionStorage')
  const res = await fetch(`${BASE_URL}/${GET_TAN_BY_ENTITY_UUID_API}/${uuid}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })

  if (!res.ok) throw new Error(`Failed to get entity types: ${res.status}`)
  return await res.json()
} 